import React, { useState } from 'react';
import { buildComstockGeoDev } from '/imports/api/devtools';
import { toastOnError } from '/imports/ui/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';

/**
 * Dev tool panel that triggers building the ComStock county→climate-zone crosswalk and shows the result.
 */
export const DevToolComstockGeo = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState('');
  const run = toastOnError(async () => {
    setLoading(true);
    setResult('');
    try {
      const res = await buildComstockGeoDev.call();
      setResult(JSON.stringify(res, null, 2));
    }
    finally {
      setLoading(false);
    }
  });
  return (
    <DevToolSection
      title="Build ComStock Geo"
      description="Build the ComStock county→climate-zone crosswalk (geo.json) on this host. It's used by the interval-data simulator's climate-zone fallback. Run once per environment, and again whenever the ComStock release changes."
      onRun={() => run()}
      loading={loading}
      buttonText="Build"
    >
      {result && <pre>{result}</pre> || null}
    </DevToolSection>
  );
};
